import { StyledBodyText } from './BodyText.styles';

interface BodyTextProps {
    children: React.ReactElement;
    color?: string;
}

export const BodyText = ({ children, color }: BodyTextProps) => {
    return <StyledBodyText color={color}>{children}</StyledBodyText>;
};
